import React from 'react';

export default () => (
  <>
    <h1>How did you get here, SNEAKY</h1>
  </>
);
